import cogoToast from "cogo-toast";
import React, { createRef, useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useRejectDocumentMutation } from "../../../../../../../../../../redux/apiSlice";
import { defaultRejectReason } from "./DefaultRejectReason";


const Reject = ({ doc, cancel, refreshDocs }) => {

    const [rejectDocument, { isLoading, isSuccess, data },] = useRejectDocumentMutation();
    const isSuccessRef = useRef(false);

    const userId = useSelector(state => state.auth.user.id);
    // Retrieve from Local Storage
    const rejectReason = JSON.parse(localStorage.getItem(`${userId}:document`)) ?? defaultRejectReason;

    const [reason, setReason] = useState(rejectReason);
    const [reasonId, setReasonId] = useState(null);

    const scrollTrack = useRef(null);
    const viewRef = createRef();
    const inputContRef = createRef()
    const textAreaRef = createRef()

    // Choose Reason from Options
    const selectedReason = id => _ => {
        setReasonId(id);
        textAreaRef.current.value = reason.find(val => val.id === id)['text'] + " ";
        textAreaRef.current.focus();
        inputContRef.current.scrollIntoView({ behavior: 'smooth' });
    }

    // Delete Rejecty Reason
    const delReason = id => e => {
        e.preventDefault();
        e.stopPropagation();
        const updateReason = reason.filter(res => res.id !== id);
        localStorage.setItem(`${userId}:document`, JSON.stringify(updateReason));
        setReason(updateReason);
    }

    // Reject Document Request
    const handleSubmit = e => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;

        if (form.checkValidity()) {
            const formData = new FormData(form);
            const docData = { ...doc, ...Object.fromEntries(formData.entries()), meta: doc };

            if (docData.save) {
                const text = docData.rejectionReason.trim();
                const updateReason = reason.filter(res => res.text !== text); // Avoid Duplicate 
                updateReason.push({ id: Math.random().toString(36).substr(2, 6), text });
                localStorage.setItem(`${userId}:document`, JSON.stringify(updateReason));
                setReason(updateReason);
            }
            isSuccessRef.current = true;
            rejectDocument(docData);
        }
    }

    /* Auto scroll to component in focus */
    useEffect(() => {
        if (scrollTrack.current === null) {
            viewRef.current.scrollIntoView({ behavior: 'smooth' });
            setTimeout(_ => scrollTrack.current = doc.documentId, 1000)
        }
    });

    // Successful Rejection
    useEffect(() => {
        if (isSuccess && isSuccessRef.current) {
            isSuccessRef.current = false;
            cogoToast.success("Document Rejected");
            refreshDocs(data);
            cancel();
        }
    }, [isSuccess, data, cancel, refreshDocs]);

    return <div className="px-20" ref={viewRef}>
        {reason.map(({ id, text }, i) => <button
            key={`reason-${i}`}
            onClick={selectedReason(id)}
            className={`btn btn-outline-secondary btn-block text-left mb-5 p-4 ${id === reasonId && "active"}`}
        >

            <span
                className="close  border px-1 border-danger rounded-circle text-danger"
                onClick={delReason(id)}
            >
                <span aria-hidden="true" className="d-block">×</span>
                <span className="sr-only">Close</span>
            </span>
            {text}
        </button>
        )
        }

        <div ref={inputContRef}>
            <Form
                onSubmit={handleSubmit}
            >
                <textarea rows="4" ref={textAreaRef} className="form-control my-3" required name="rejectionReason"></textarea>
                <div className="form-check mt-4">
                    <input className="form-check-input" type="checkbox" id="defaultCheck1" name="save" value="save" />
                    <label className="form-check-label ml-4" htmlFor="defaultCheck1">
                        Save Reject Reason
                    </label>
                </div>
                <div className="row mt-5">

                    <div className="col-md">
                        <button
                            type="button"
                            className="btn btn-secondary btn-sm btn-block"
                            disabled={isLoading}
                            onClick={cancel}
                        >
                            Cancel
                        </button>
                    </div>
                    <div className="col-md">
                        <button
                            type="submit"
                            className="btn btn-danger btn-sm btn-block"
                            disabled={isLoading}
                        >
                            Reject
                        </button>
                    </div>

                </div>
            </Form>
        </div>

    </div>
}

export default Reject;